import React from "react";
import { PageHeader } from "./PageHeader";
import { DataBox } from "./DataBox";

export function CustomerStatistics() {
    return (
        <>
            <PageHeader />
            <DataBox />
        </>
    );
}

